import { render, staticRenderFns } from "./ServiceSummary.vue?vue&type=template&id=53b60dea&scoped=true"
import script from "./ServiceSummary.vue?vue&type=script&lang=js"
export * from "./ServiceSummary.vue?vue&type=script&lang=js"
import style0 from "./ServiceSummary.vue?vue&type=style&index=0&id=53b60dea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b60dea",
  null
  
)

export default component.exports